import Vue from 'vue'
import Vuex from 'vuex'
import VisaSingle from '../store/modules/visa/single'
import CountryForTouristList from './modules/country/list'
import Notification from '../store/modules/notification/notification'
import VisaType from '../store/modules/visa_type';
import Office from '../store/modules/office';
import AirPort from './modules/airport'
import DynamicValues from '../store/modules/dynamic_values'

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        VisaSingle,
        CountryForTouristList,
        VisaType,
        Notification,
        Office,
        AirPort,
        DynamicValues,
    }
});

export default store
